import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { END } from "redux-saga";
import { wrapper } from "@/store";
import App from "@/components/app-controller";
import { modules } from "@/config/pages/modules";
import CustomLinkReact from "@/bit/components/react-components.custom-link";
import { BrowserRouter as Router } from "react-router-dom";
import Footer from "@/bit/components/components.footer";
import PageHandler from "@/components/page-handler";
import { getJWTCloudRun } from "@gcloud-npm/node.ssr-process.google-auth-revalidate";
import getByName from "@gcloud-npm/adabyron.custo.get-by-name";
import { actions as userActions } from "@/reducers/user";
import { actions as productsActions } from "@/reducers/product";
import { ENV_NAME } from "@gcloud-npm/utils.enums.environment";
import { findOutEnvByEnvName } from "@gcloud-npm/utils.enums.environment";
import { actions as clientActions} from '@/reducers/client'
import { actions as headerActions } from "@/bit/reducers/reducers.header-reducer";
import getPageProps from "@gcloud-npm/adabyron.page.get-props";
import setCookie from "@gcloud-npm/utils.common.set-cookie"


const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;

class NextLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      reactAccountLinks: null,
      reactBreadcrumbsLinks: null,
      customDynamicPart: null,
    };
  }

  setColOriginCookie() {
    // col-origin=“col-app-prod-v1.001”
    const cookieName = "col-origin";
    const cookieValue = `col-web-${currentEnv}-${process.env.NEXT_PUBLIC_VERSION_JS}`
    setCookie(cookieName, cookieValue, 365 ,'movistar.es.telefonica')
  }

  componentDidMount() {
    const { userInit, getMyProducts, externalPage = false } = this.props;
    this.setState({
      loaded: true,
    });
    if (userInit && !externalPage) {
      userInit();
    }
    // getMyProducts();
    switch(currentEnv) {
      case ENV_NAME.CERT:
      case ENV_NAME.INTE:
      case ENV_NAME.PREPROD:
        setColOriginCookie();
      break;
      default: break;
    }


  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      loaded,
      reactAccountLinks,
      reactBreadcrumbsLinks,
      customDynamicPart,
    } = this.state;
    const {
      loaded: nextLoaded,
      reactAccountLinks: nextReactAccountLinks,
      reactBreadcrumbsLinks: nextReactBreadcrumbsLinks,
      customDynamicPart: nextCustomDynamicPart,
    } = nextState;
    const cndLoaded = loaded !== nextLoaded;
    const accountLinksChange =
      JSON.stringify(reactAccountLinks) !==
      JSON.stringify(nextReactAccountLinks);
    const breadcrumbChange =
      JSON.stringify(reactBreadcrumbsLinks) !==
      JSON.stringify(nextReactBreadcrumbsLinks);

    const customDynamicPartHasChange =
      customDynamicPart !== nextCustomDynamicPart;

    if (
      cndLoaded ||
      accountLinksChange ||
      breadcrumbChange ||
      customDynamicPartHasChange
    ) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return true;
    }
    return false;
  }

  onReceivePageProps = ({ breadcrumbs, account, customDynamicPart }) => {
    this.setState({
      reactBreadcrumbsLinks: breadcrumbs,
      reactAccountLinks: account,
      customDynamicPart,
    });
  };

  render() {
    const { loaded, reactBreadcrumbsLinks, reactAccountLinks } = this.state;
    const {
      context,
      seoInfoProps,
      headerProps,
      breadcrumbsProps,
      footerProps,
      paths,
      children,
    } = this.props;

    return (
      <>
        <PageHandler
          seoInfoProps={seoInfoProps}
          headerProps={headerProps}
          breadcrumbsProps={breadcrumbsProps}
          context={context}
          onReceivePageProps={this.onReceivePageProps}
        />
        <div className="area-main-content">
          {children && <div id="static-content">{children}</div>}
          {loaded && (
            <Router key="router-app">
              <App key="app-core" urlLibrary={paths} modulesLibrary={modules} />
              <div id="header-react-links">
                {reactAccountLinks &&
                  Object.keys(reactAccountLinks).length > 0 &&
                  Object.keys(reactAccountLinks).map((keyName) => {
                    const currentItem = reactAccountLinks[keyName];
                    if (currentItem && currentItem.reactLink) {
                      return (
                        <CustomLinkReact
                          id={`react-${currentItem.reactLink}`}
                          href={currentItem.link}
                        >
                          {keyName}
                        </CustomLinkReact>
                      );
                    }
                  })}
              </div>
              <div id="header-breadcrumb-links">
                {reactBreadcrumbsLinks &&
                  Object.keys(reactBreadcrumbsLinks).length > 0 &&
                  Object.keys(reactBreadcrumbsLinks).map((keyName) => {
                    let currentItem = reactBreadcrumbsLinks[keyName];
                    currentItem = currentItem.replace(/react:/g, "");
                    const breadid = `react-${keyName.replace(/ /g, "")}`;
                    // enriquecemos el entorno
                    if (currentEnv !== 'prod') {
                      switch(currentEnv){
                        case 'inte':
                          currentItem = currentItem.replace("https://www.movistar.es/", "https://www.movistar.es.inte/");
                          break;
                        case 'cert':
                          currentItem = currentItem.replace("https://www.movistar.es/", "https://www.movistar.es.cert/");
                          break;
                        case 'preprod':
                          currentItem = currentItem.replace("https://www.movistar.es/", "https://www.movistar.es.telefonica/");
                          break;
                        case 'dev':
                          currentItem = currentItem.replace("https://www.movistar.es/", "https://www.movistar.es/develop/");
                          break;
                        case 'qa':
                        default: 
                          currentItem = currentItem.replace("https://www.movistar.es/", "https://www.movistar.es/qa/");
                          break;
                      }
                    }
                    return (
                      <CustomLinkReact id={breadid} href={currentItem}>
                        {keyName}
                      </CustomLinkReact>
                    );
                  })}
              </div>
            </Router>
          )}
          <style jsx>{`
            .area-main-content {
              min-height: 75vh;
              margin: 1.5rem auto;
              #header-breadcrumb-links,
              #header-react-links {
                display: none;
              }
            }
          `}</style>
        </div>
        <Footer footerProps={footerProps} />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  userInit: () => dispatch(userActions.userInit()),
  getMyProducts: () => dispatch(productsActions.getMyProducts()),
});


export default connect(null, mapDispatchToProps)(NextLanding);

export const getStaticPaths = async () => {
  
  let paths = [];
  const context = {
    environment: findOutEnvByEnvName(process.env.NEXT_PUBLIC_ENV_NAME),
  };
  try {
    const custoHeaders = await getJWTCloudRun("custo-standard");
    let info = null;
    if (currentEnv !== ENV_NAME.LOCAL && currentEnv !== ENV_NAME.CODE) {
      info = await getByName({
        name: "ssr-area-cliente-vpaths",
        context: context,
        build: true,
        kind: "creativity",
        ssrHeaders: custoHeaders,
      });
    } else {
      info = require("@/mocks/custo_urls.json");
    }
    info.forEach((item) => {
      if (item && item.pathName && item.pathName !== "*") {
        let ruta = `${item.pathName}`;
        paths.push(ruta);
      }
    });
    paths = paths.filter(item => item.indexOf('mi-cuenta'))
  } catch (e) {
    console.error(e);
  }
  return {
    paths,
    fallback: false,
  };
};

export const spaGetStaticProps = async (data) => {
  const { store, pathName2render } = data;
    const custoHeaders = await getJWTCloudRun("custo-standard");
    const ssrHeaders = await getJWTCloudRun("ssr-backend");
    const bucketHeaders = await getJWTCloudRun("bucket");
    let revalidate = 60;
    if (currentEnv === "prod") {
      revalidate = 300;
    }
  
    const context = store.getState().main.context;
  
    let paths = null;
  
    if (currentEnv !== ENV_NAME.LOCAL) {
      paths = await getByName({
        name: "ssr-area-cliente-vpaths",
        context: context,
        build: true,
        kind: "creativity",
        ssrHeaders: custoHeaders,
      });
    } else {
      paths = require("@/mocks/custo_urls.json");
    }
  
    const headerLocation = "/area-cliente";
    let headerInfo = null;
    let seoInfoProps = null;
    let footerProps = null;
    let pageInfoJson = null;
    let seoLocation = `www.movistar.es/${headerLocation}/${pathName2render}`
    seoLocation = seoLocation.replace(/\/\//g, '/');
    if (currentEnv !== ENV_NAME.LOCAL) {
      pageInfoJson = await getPageProps({
        context,
        build: true,
        seoLocation,
        headerLocation,
        footerLocation: headerLocation,
        ssrHeaders,
      });
    } else {
      pageInfoJson = require("@/mocks/page_info.json");
    }
    // const
    ({ seo: seoInfoProps, header: headerInfo, footer: footerProps } = pageInfoJson);
    const { breadcrumbsProps, headerProps } = headerInfo;
  
    // FOOTER USUAL PROPS
    
    if (currentEnv === ENV_NAME.LOCAL) {
      footerProps = require("@/mocks/footer.json");
    }
    store.dispatch(clientActions.setUrlsClient(paths));
    store.dispatch(headerActions.setupHeaderProps(headerProps));
    store.dispatch(END);
    await store.sagaTask.toPromise();
  
    return {
      props: {
        seoInfoProps: seoInfoProps || {},
        headerProps,
        breadcrumbsProps,
        footerProps,
        paths,
        context,
      },
      revalidate,
    };
}

export const getStaticProps = wrapper.getStaticProps(async (data) => {
  const { store, params } = data;
  let pathName2render = '';
  if (params && params.slug ) {
    pathName2render = params.slug.join('/');
  }
  return await spaGetStaticProps({store, pathName2render})
});
